/*
 * @Author: sipeng
 * @LastEditTime: 2022-09-08 10:21:02
 * @Description:
 * @LastEditors: Please set LastEditors
 */
export default {
  sourceFile: 'Source File',
  queryFile: 'Query File',
  fileName: 'File Name',
  uploader: 'Uploader',
  uploadDate: 'Upload Date',
  basicProperties: 'Basic Properties',
  objectEncoding: 'Object Encoding',
  objectName: 'Object Name',
  source: 'Source',
  queryTagCodeOrTagName: 'Query Tag Code or Tag Name',
  confirmSelection: 'Confirm Selection',
  reselect: 'Reselect',
  consistencySettings: 'Consistency Settings',
  mainData: 'Main Data',
  pleaseSelectTheSourceFile: 'Please Select The Source File!',
  pleaseSelectTheAttributeValueInformationYouWantToModify:
    'Please Select The Attribute Value Information You Want to Modify!',
  attributeConsistencyIsNotSelectedPleaseReSelectAndContinue:
    'Attribute Consistency is Not Selected, Please Re-select and Continue!',
  editedSuccessfully: 'Edited Successfully!',
  setupSuccessful: 'Setup Successful!',
  editTheObjectInformation: 'Edit The Object Information',
  whetherToConfirmThatTheSelectedDataIsSelected:
    'Whether to Confirm That The Selected Data is Selected',
}
